// extracted by mini-css-extract-plugin
module.exports = {"agreement-link":"_0cbaba7d8a--agreement-link--CJ82B"};